// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 持久化类型枚举 枚举类
 * 持久化类型枚举
 */
export enum EnumPersistenceType {
  /** 不持久化 : 不持久化 */
  None = 0,
  /** 关系型数据库 : 关系型数据库 */
  RMDB = 1,
  /** XML文件 : XML文件 */
  XML = 2
}

/**
 * 持久化类型枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumPersistenceTypeMD {
  private static items = [
    new EnumItemMD('None', 0, '不持久化', '不持久化'),
    new EnumItemMD('RMDB', 1, '关系型数据库', '关系型数据库'),
    new EnumItemMD('XML', 2, 'XML文件', 'XML文件')
  ];

  static getItem(enumItem: EnumPersistenceType) {
    return this.items.find(item => item.name === EnumPersistenceType[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
